/*=========================================================================================
  File Name: moduleStatusMutations.js
  Description: Status Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	// Asigna los status al state
	SET_STATUS(state, status) {
		state.status = status;
	},
	// Insertar status individual al state
	SET_STATUS_ONLY(state, data) {
		state.status.push(data);
	},
	// Actualizar status modificado en el state
	UPDATE_STATUS(state, data) {
		let findIndex = state.status.findIndex((p) => p.id === data.id);
		state.status[findIndex] = data;
	},
	// elimina el Status seleccionado del state
	REMOVE_STATUS(state, itemId) {
		const ItemIndex = state.status.findIndex((p) => p.id === itemId);
		state.status.splice(ItemIndex, 1);
	},
};
